<template>
    <div class="change">
        <el-dialog title="请确认以下核心商品机制的变更" width="30%" :visible.sync="dialogChangeVisible">
            <div class="tipsBox">
                <tips-box></tips-box>
            </div>
            <div class="product_box">
                <product-box :row="row"></product-box>
            </div>
            <div class="user_info_box mt-10">
                <user-info-box  :row="row"></user-info-box>
            </div>
            <div class="flex mt-20">
                <div class="table">
                    <div class="tr flex font-bold yx-color-text-primary">
                        <p class="th">变更项目</p>
                        <p class="th">变更前</p>
                        <p class="th third">变更后</p>
                    </div>
                    <div class="tr flex" v-for="(item,index) in changeArr" :key="index">
                        <p>{{ item.name }}</p>
                        <p>{{ beforeObj[item.field] }}</p>
                        <p class="third">{{ afterObj[item.field] }}</p>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogChangeVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeConfirm">确认变更</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
import {  editProduct } from '@/api/cooperationProgress';
export default {
    name: 'change',
    components: {
        productBox,
        userInfoBox,
        tipsBox
    },
    data() {
        return {
            dialogChangeVisible: false,
            changeArr: [],
            beforeObj: {},
            afterObj: {},
            row: {}
        }
    },
    methods: {
        initChange(before, after, changeArr, row) {
            this.row = row
            this.beforeObj = before
            this.afterObj = after
            this.changeArr = changeArr
            this.dialogChangeVisible = true
        },
        async changeConfirm() {
            let afterObj = JSON.parse(JSON.stringify(this.afterObj))
            const {code} = await editProduct(afterObj)
            if(code == 0) {
                this.$message.success('操作成功')
                this.$emit('refreshList')
                this.dialogChangeVisible = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.table {
    margin: 0 auto;
}
.table p{
    width: 121px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
}
.th{
    border-top: 1px solid #ddd;
}
.third {
    border-right: 1px solid #ddd;
}
</style>